import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Icon, Notifications, Button } from "../shared";
import { useAppNavigation } from "../../hooks";

const ExpressNotificationModal = ({ show, close, appointment, notifications = [] }) => {
  const { t } = useTranslation();
  const { toFastDrop } = useAppNavigation();

  const { _id, rescheduleExpressAppointment, isCanceled, isExpired, isOrderCompleted } =
    appointment || {};

  const toReviewExpress =
    appointment && !isCanceled && !isExpired && !isOrderCompleted && rescheduleExpressAppointment;

  return (
    <>
      <Modal
        show={show}
        onHide={close}
        centered
        size="xl"
        className="appointment-notifications-modal">
        <Modal.Body className="autohub-modal comments-modal">
          <div className="close-icon">
            <Icon iconName="xmark" onClick={close} />
          </div>

          <div className="image-guide-modal-header">
            <h4>{t("track.notificationModalHeading")}</h4>
            <p>{t("track.notificationModalPara")}</p>
          </div>

          <div className="notifications-container" aria-live="polite" aria-atomic="true">
            <Notifications messages={notifications} />
            {toReviewExpress && (
              <div className="review-notification-btn">
                <Button type="blue-roundedRight" customize="m-0" action={() => toFastDrop(_id)}>
                  {t("track.reviewAppointment")}
                </Button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default React.memo(ExpressNotificationModal);
